import Enumeration from 'Lib/utilities/Enumeration';

const SettlementTypes = new Enumeration([
    { id: 1, key: 'ElectronicCheck', name: 'Electronic Check (ACH)' },
    { id: 2, key: 'ACH', name: 'NACHA (ACH)' },
    { id: 3, key: 'CashPay', name: 'Cash Pay' }
]);

export default SettlementTypes;
